import React, { Component } from "react";
import { Button } from "@material-ui/core";
import { ValidatorForm } from "react-material-ui-form-validator";
import ValidationRules from "../../../../common/ValidationRules";
import NscDeliveryRangesRow from "./deliveryRangesRow/NscDeliveryRangesRow";
import styles from "./NscDeliveryRanges.module.scss";
import { withTranslation } from "react-i18next";
import ConfirmDialog from "../../../../shared/confirmDialog/ConfirmDialog";
import NscDeliveryRowDisplay from "./deliveryRangesRow/NscDeliveryRowDisplay";
import { InfoIconWithMessage } from "../../../../shared/infoIcon/InfoIcon";
import HasPermissionTo from "../../../../common/HasPermissionTo";
import NscDeliveryRangesClient from "../../../../shared/clients/NscDeliveryRangesClient";
import { StyledDivider } from "../../../../shared/Dividers/StyledDivider";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./NscDeliveryRanges.module.scss";
import UiDateUtils from "../../../../utils/UiDateUtils";
import PendingActionClient from "../../../../shared/clients/PendingActionClient";
import { DELIVERY_BANDS } from "../../../../common/Constants";
import { TableHeader } from "./TableHeader";

class NscDeliveryRanges extends Component {
  constructor(props) {
    super(props);

    this.state = {
      defaultNoOfRows: 2,
      currentNoOfRows: 2,
      openDialog: false,
      dataLoaded: false,
      hideCreateZoneButton: false,
      deliveryRangesApplied: false,
      oldRanges: [],
      deliveryOptionForOldRange: null,
      newRanges: [],
      deliveryOptionForNewRange: true,
      effectiveDate: new Date(),
      selectedMarket:
        this.props.selectedMarket && this.props.selectedMarket.length > 0
          ? this.props.selectedMarket
          : this.props.user.market,
    };
    this.showNewVersion =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "newDeliveryRangesView"
      );
    this.maxNoOfRows = 5;
    this.currencySymbol =
      this.props.localizedInfo && this.props.localizedInfo.defaultCurrency
        ? this.props.localizedInfo.defaultCurrency.symbol
        : "NA";
    this.distanceUnit =
      this.props.localizedInfo && this.props.localizedInfo.defaultDistanceUnit
        ? this.props.localizedInfo.defaultDistanceUnit
        : "NA";

    this.deleteRangeDialogProps = {
      title: this.props.t("nscDeliveryBands.deleteRangeTitle"),
      bodyText: this.props.t("nscDeliveryBands.deleteRangeBody"),
      confirm: this.props.t("nscDeliveryBands.deleteRangeConfirm"),
      cancel: this.props.t("nscDeliveryBands.deleteRangeCancel"),
    };

    this.canEditDeliveryRanges =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "deliveryRanges:write"
      );

    this.handleTextOnChange = this.handleTextOnChange.bind(this);
  }

  componentDidMount() {
    ValidatorForm.addValidationRule("checkingRows", (fromVal, currentRow) => {
      let isValid = true;
      if (currentRow < 1 || this.state.newRanges[currentRow - 1].to === null) {
        isValid = true;
      } else if (
        this.state.newRanges[currentRow - 1].to === "" ||
        isNaN(this.state.newRanges[currentRow - 1].to) ||
        fromVal === ""
      ) {
        isValid = true;
      } else if (
        parseInt(fromVal) !==
        parseInt(this.state.newRanges[currentRow - 1].to) + 1
      ) {
        isValid = false;
      }

      return isValid;
    });

    /**
     * Checking the input value is zero or noe
     * Validation Fails - if the input value has other than 0-9
     */
    ValidatorForm.addValidationRule("shouldBeZero", (value, index) => {
      // eslint-disable-next-line
      if (index != 0) return true;
      const re = /^[0\b]+$/;
      let isValid = true;
      if (value !== "" && !re.test(value)) {
        isValid = false;
      }
      return isValid;
    });
    ValidationRules();
    this.fetchRanges();
  }

  handleDeleteAction = () => this.setState({ openDialog: true });

  handleTextOnChange(event) {
    const ranges = JSON.parse(JSON.stringify(this.state.newRanges));

    if (event.target.name === "rangeFrom" + event.target.id) {
      ranges[event.target.id].from = event.target.value;
      this.setState({ newRanges: ranges });
    } else if (event.target.name === "rangeTo" + event.target.id) {
      ranges[event.target.id].to = event.target.value;
      const textEvent = event.target;
      this.setState(
        {
          newRanges: ranges,
        },
        () => {
          if (!isNaN(textEvent.value)) {
            this.autoIncrementNxtRowFromValue(textEvent.id);
          }
        }
      );
    } else if (event.target.name === "rangeValue" + event.target.id) {
      ranges[event.target.id].value = event.target.value;
      this.setState({ newRanges: ranges });
    }
  }

  handleSubmit = () => {
    let isValidInput = true;
    const ranges = JSON.parse(JSON.stringify(this.state.newRanges));
    const length = ranges.length;
    for (let index = 0; index < length; ++index) {
      const to = ranges[index].to;
      if (to && isNaN(to) && to.toUpperCase() === "OVER") {
        if (index !== length - 1) {
          ranges[index].to = null;
          isValidInput = false;
          break;
        } else {
          ranges[index].to = null;
        }
      }
      if (ranges[index].to !== null && ranges[index].to !== "") {
        ranges[index].to = parseInt(ranges[index].to);
      }
      ranges[index].from = parseInt(ranges[index].from);
      ranges[index].value = parseFloat(ranges[index].value);
    }

    this.setState({ newRanges: ranges });

    isValidInput &&
      this.saveDeliveryRanges(this.state.newRanges)
        .then((status) => {
          if (status === 200) {
            this.props.hideOrShow(false);
            PendingActionClient.removeNscPendingAction(
              this.props.user,
              DELIVERY_BANDS,
              null,
              this.state.selectedMarket
            );
          }
        })
        .catch(() => {
          this.setState({
            deliveryRangesApplied: false,
          });
        })
        .finally(() => {
          this.setState({
            deliveryRangesApplied: true,
          });
        });
  };

  handleRangesFromEMP = (result, setAsOld) => {
    if (result && result.deliveryRanges && result.deliveryRanges.length > 0) {
      this.setStateForRanges(
        setAsOld,
        result.deliveryRanges,
        result.freeDelivery,
        result.effectiveDate
      );
    }
  };

  setStateForRanges = (old, ranges, freeDelivery = null, date) => {
    if (old) {
      this.setState({
        oldRanges: ranges,
        deliveryOptionForOldRange: freeDelivery,
      });
    } else {
      this.setState({
        newRanges: ranges,
        deliveryOptionForNewRange: freeDelivery,
        effectiveDate: date && new Date(date),
        deliveryRangesApplied: true,
      });
    }
  };

  fetchRanges = async () => {
    this.props.hideOrShow(true);
    const empResponse = await this.fetchFromEMP();

    this.handleRangesFromEMP(empResponse && empResponse.result, true);
    this.handleRangesFromEMP(empResponse && empResponse.newResult, false);

    this.props.hideOrShow(false);
    this.setState({
      dataLoaded: true,
    });
  };

  fetchFromEMP() {
    return NscDeliveryRangesClient.getDeliveryRangesNew(
      this.props.user,
      this.state.selectedMarket
    ).then((data) => {
      return data;
    });
  }

  async saveDeliveryRanges(ranges) {
    this.props.hideOrShow(true);
    const data = {};
    data.deliveryRanges = ranges;
    data.freeDelivery = this.state.deliveryOptionForNewRange;
    data.effectiveDate = this.state.effectiveDate.setHours(0, 0, 0, 0);
    return await NscDeliveryRangesClient.saveDeliveryRangesNew(
      data,
      this.props.user,
      this.state.selectedMarket
    );
  }

  addRow = () => {
    if (this.state.currentNoOfRows === this.maxNoOfRows) {
      return;
    }
    const ranges = JSON.parse(JSON.stringify(this.state.newRanges));
    ranges.push({ from: "", to: "", value: "" });

    this.setState(
      {
        newRanges: ranges,
        currentNoOfRows: ranges.length,
      },
      () => {
        const ranges = JSON.parse(JSON.stringify(this.state.newRanges));
        let previousRowToVal = ranges[ranges.length - 2].to;
        if (
          previousRowToVal !== null &&
          previousRowToVal !== "" &&
          !isNaN(previousRowToVal)
        ) {
          ranges[ranges.length - 1].from = ++previousRowToVal;
          this.setState({ newRanges: ranges });
        }
      }
    );
  };

  deleteRow = () => {
    if (this.state.currentNoOfRows === this.state.defaultNoOfRows) {
      return;
    }

    const dataObjRow = JSON.parse(JSON.stringify(this.state.newRanges));
    let rangeRows = this.state.currentNoOfRows;

    dataObjRow.pop(dataObjRow.length - 1);

    this.setState({
      newRanges: dataObjRow,
      currentNoOfRows: --rangeRows,
      openDialog: false,
    });
  };

  autoIncrementNxtRowFromValue(rowId) {
    const ranges = JSON.parse(JSON.stringify(this.state.newRanges));
    let rowValue = ranges[rowId].to;
    const currentRow = parseInt(rowId);

    if (currentRow + 1 < this.state.currentNoOfRows) {
      if (rowValue !== "") {
        ranges[currentRow + 1].from = ++rowValue;
      } else {
        ranges[currentRow + 1].from = null;
      }
    }

    this.setState({ newRanges: ranges });
  }

  createNewDeliveryZone = () => {
    this.setState({
      hideCreateZoneButton: true,
      newRanges: this.setDefaultRanges(),
    });
  };

  selectDeliveryOption = () => {
    this.setState({
      deliveryOptionForNewRange: !this.state.deliveryOptionForNewRange,
    });
  };

  selectEffectiveDate = (date) => {
    if (date !== null) {
      this.setState({ effectiveDate: date });
    }
  };

  checkRanges = () => {
    if (this.state.effectiveDate === "") return false;

    for (let i = 0; i < this.state.newRanges.length; i++) {
      if (Object.values(this.state.newRanges[i]).includes("")) {
        return false;
      }
    }

    return true;
  };

  getHeader = () => {
    return this.state.deliveryRangesApplied && this.showNewVersion
      ? `${this.props.t("nscDeliveryBands.newZonesEffectiveHeader")} 
    ${UiDateUtils.formatDateDDMMYYYY(this.state.effectiveDate)}`
      : this.canEditDeliveryRanges &&
          this.props.t("nscDeliveryBands.createNewZonesHeader");
  };

  getSubHeader = () => {
    let subHeader;

    if (this.state.deliveryRangesApplied && this.showNewVersion) {
      subHeader = `${this.props.t("BusinessSettings.effectiveFrom")} 
    ${UiDateUtils.formatDateDDMMYYYY(this.state.effectiveDate)}`;
    } else if (this.state.hideCreateZoneButton) {
      subHeader = this.props.t("nscDeliveryBands.subheader");
    } else {
      subHeader =
        this.canEditDeliveryRanges &&
        this.props.t("nscDeliveryBands.createNewZonesSubHeader");
    }

    return subHeader;
  };

  setDefaultRanges() {
    return [
      { from: "0", to: "", value: "" },
      { from: "", to: "", value: "" },
    ];
  }

  render() {
    return (
      this.state.dataLoaded && (
        <section className="pageWrapper">
          <ConfirmDialog
            open={this.state.openDialog}
            dialogProps={this.deleteRangeDialogProps}
            onConfirm={this.deleteRow}
            onCancel={() => this.setState({ openDialog: false })}
            onClose={() => this.setState({ openDialog: false })}
            boldTitle={false}
            {...this.props}
          />

          {this.state.oldRanges.length > 0 && (
            <div className="pagePaddingTop">
              {/*-------------Old----------------*/}
              <TableHeader
                {...this.props}
                headers={[
                  `${this.props.t("nscDeliveryBands.bands")} (${
                    this.distanceUnit
                  })`,
                  this.props.t("nscDeliveryBands.offerFreeDelivery"),
                  `${this.props.t("nscDeliveryBands.charge")} (${
                    this.currencySymbol
                  })`,
                ]}
              />
              {this.state.oldRanges.map((range, index) => {
                return (
                  <NscDeliveryRowDisplay
                    id="deliveryDisplay"
                    deliveryOption={
                      index === 0 ? this.state.deliveryOptionForOldRange : null
                    }
                    range={range}
                    key={index}
                  />
                );
              })}
            </div>
          )}

          {/*-------------New----------------*/}
          <HasPermissionTo
            perform={["deliveryRanges:read"]}
            permissions={this.props.user.permissions.rolePermissions}
            render={() => (
              <div className="pagePaddingTop">
                <StyledDivider text={this.getHeader()} indent={true} />

                <div className="pagePaddingLeft">
                  <InfoIconWithMessage message={this.getSubHeader()} />
                </div>

                {!this.state.hideCreateZoneButton &&
                  !this.state.newRanges.length > 0 &&
                  this.canEditDeliveryRanges && (
                    <Button
                      id="addDeliveryRangeBtn"
                      data-testid="addDeliveryRangeBtn"
                      className={styles.add}
                      onClick={() => this.createNewDeliveryZone()}
                      component="button"
                    >
                      {this.props.t("nscDeliveryBands.createNewZone")}
                    </Button>
                  )}
              </div>
            )}
          />

          <HasPermissionTo
            perform={["deliveryRanges:read"]}
            permissions={this.props.user.permissions.rolePermissions}
            condition={
              this.state.hideCreateZoneButton || this.state.newRanges.length > 0
            }
            render={() => (
              <div className="pagePaddingTop">
                <TableHeader
                  {...this.props}
                  headers={[
                    `${this.props.t("nscDeliveryBands.bands")} (${
                      this.distanceUnit
                    })`,
                    this.showNewVersion &&
                      this.props.t("nscDeliveryBands.offerFreeDelivery"),
                    `${this.props.t("nscDeliveryBands.charge")} (${
                      this.currencySymbol
                    })`,
                  ]}
                />
                {this.state.deliveryRangesApplied ? (
                  <>
                    {this.state.newRanges.map((range, index) => {
                      return (
                        <NscDeliveryRowDisplay
                          id="deliveryDisplay"
                          deliveryOption={
                            this.showNewVersion && index === 0
                              ? this.state.deliveryOptionForNewRange
                              : null
                          }
                          range={range}
                          key={index}
                        />
                      );
                    })}
                    <div
                      data-testid="pricesApplied"
                      className={`${styles.pricesApplied} pagePaddingTop`}
                    >
                      <div>
                        {this.props.t("nscDeliveryBands.applied")} &#10003;
                      </div>
                      <div>
                        {this.showNewVersion &&
                          `${this.props.t("BusinessSettings.effectiveFrom")} 
                        ${UiDateUtils.formatDateDDMMYYYY(
                          this.state.effectiveDate
                        )}`}
                      </div>
                    </div>
                  </>
                ) : (
                  <ValidatorForm onSubmit={this.handleSubmit}>
                    {this.state.newRanges.map((item, index) => {
                      return (
                        <NscDeliveryRangesRow
                          freeDeliveryOption={
                            this.showNewVersion && index === 0
                          }
                          freeDelivery={this.state.deliveryOptionForNewRange}
                          dataObjItem={item}
                          action={this.handleTextOnChange}
                          deleteAction={this.handleDeleteAction}
                          defaultNoOfRows={this.state.defaultNoOfRows}
                          currentNoOfRows={this.state.currentNoOfRows}
                          currentRow={index}
                          selectDeliveryOption={this.selectDeliveryOption}
                        />
                      );
                    })}

                    <div>
                      {this.state.currentNoOfRows === this.maxNoOfRows ? (
                        <p className={styles.max}>
                          {this.props.t("nscDeliveryBands.maxRows")}
                        </p>
                      ) : (
                        <Button
                          id="addDeliveryRangeBtn"
                          className={styles.add}
                          onClick={this.addRow}
                          component="button"
                        >
                          {this.props.t("nscDeliveryBands.add")}
                        </Button>
                      )}
                    </div>
                    {this.showNewVersion && (
                      <div className={styles.effectiveDateRow}>
                        <span className={styles.effectiveText}>
                          {this.props.t("BusinessSettings.effectiveFrom")}
                        </span>
                        <DatePicker
                          selected={this.state.effectiveDate}
                          onChange={this.selectEffectiveDate}
                          id="input"
                          dateFormat="dd/MM/yy"
                          placeholderText="DD/MM/YY"
                          minDate={new Date()}
                        />
                      </div>
                    )}

                    <div className={styles.actionSection}>
                      {this.checkRanges() && (
                        <Button
                          data-testid="APPLY-BUTTON"
                          type="submit"
                          className={styles.saveBtn}
                          component="button"
                          disabled={this.state.deliveryRangesApplied}
                        >
                          {this.props.t("nscDeliveryBands.submit")}
                        </Button>
                      )}
                    </div>
                  </ValidatorForm>
                )}
              </div>
            )}
          />
        </section>
      )
    );
  }
}

export default withTranslation("emp")(NscDeliveryRanges);
